<template>
  <div>
    <div v-if="(currentStoreDoc && !timer) || !isInStoreMenu">
      <header v-if="!(isWC() && !isMobile()) && isShowHeader" :style="style">
        <overlay :isActive="showOverlay" @closed="setShowOverlay(false)"></overlay>
        <top-menu @open-overlay="setShowOverlay(true)" />
      </header>
      <header v-else-if="isWC()" :style="style">
        <overlay :isActive="showOverlay" @closed="setShowOverlay(false)"></overlay>
      </header>
      <section class="container-fluid p-0">
        <slot />
      </section>
    </div>
    <div v-if="(!currentStoreDoc || timer) && isInStoreMenu" class="d-flex skeleton-container">
        <body-skeleton></body-skeleton>
    </div>
    
  </div>
</template>
<script>
import TopMenu from "./../shared/TopMenu.vue";
import overlay from "./overlay.vue";
import { mapGetters, mapMutations } from "vuex";
import BodySkeleton from './BodySkeleton.vue';
//import PageFooter from "./../shared/footer.vue";
export default {
  components: {
    TopMenu,
    //PageFooter,
    overlay,
    BodySkeleton
  },
  created() {
    this.isInStoreMenu = !!this.$route.matched.find((route) => {
      return route.name === "store";
    });
  },
  data() {
    return {
      isInStoreMenu: false,
      loadingTime: 0,
      maxLoadingTime: 100,
      timer: null,
      style: {
        "min-height": this.isWC() ? "80px" : "0"
      }
    };
  },
  computed: {
    ...mapGetters(["showOverlay","storeMenu","storeLoaded","getloadedMenu","currentStoreDoc"]),
	isShowHeader() {
      console.log(this.$route.meta.showHeader);
      return this.$route.meta.showHeader != undefined ? this.$route.meta.showHeader : true ;
    },
  },
  watch: {
    currentStoreDoc() {
      if(!this.currentStoreDoc)
      {
        this.setloadingBarDone(false);
        this.loadingTime = 0;
        this.startTimer();
      }
    },
    $route () {
      this.isInStoreMenu = !!this.$route.matched.find((route) => {
        return route.name === "store";
      });
    },
  },
  methods: {
    ...mapMutations(["setShowOverlay","setloadingBarDone"]),
    startTimer() {
      let that = this;
      this.timer = setInterval(function() {
        that.loadingTime += 2;
        if (that.loadingTime >= that.maxLoadingTime) 
        {
          that.loadingTime = 0;
          clearInterval(that.timer);
          that.timer = null;
          that.setloadingBarDone(true);
        }
      }, 50);
    }
  },
  mounted() {
    const self = this;
    this.$root.$on('open-overlay', function() {
      self.setShowOverlay(true);
    });
  },
};
</script>
<style scoped>
  .skeleton-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  .store-loading{
    max-width: 800px;
    border-radius: 10px;
  }
</style>